// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getInputProps = (setting: any) => {
  const { key, valueType, min, max } = setting;
  const inputProps: any = {};
  const isValidInput = (value: any) => {
    if (valueType === 'numeric') {
      return value >= min && value <= max;
    }
    return true;
  };
  if (valueType === 'numeric') {
    switch (key) {
      case 'minimumLengthName':
        inputProps.min = min;
        inputProps.max = max;
        inputProps.title = `Enter a value between ${min} and ${max} for Minimum Length `;
        break;
      case 'maximumLength':
        inputProps.min = min;
        inputProps.max = max;
        inputProps.title = `Enter a value between ${min} and ${max} for Maximum Length `;
        break;
      case 'durationDays':
        inputProps.min = min;
        inputProps.max = max;
        inputProps.title = `Enter a value between ${min} and ${max} for Duration (Days)`;
        break;
      case 'minimumLengthPassword':
        inputProps.min = min;
        inputProps.max = max;
        inputProps.title = `Enter a value between ${min} and ${max} for Minimum Length Password`;
        break;
      case 'minimumNumberOfLowercaseCharacters':
        inputProps.min = min;
        inputProps.max = max;
        inputProps.title = `Enter a value between ${min} and ${max} for Minimum Number of Lowercase Characters	
        `;
        break;
      case 'minimumNumberOfUppercaseCharacters':
        inputProps.min = min;
        inputProps.max = max;
        inputProps.title = `Enter a value between ${min} and ${max} for Minimum Number of Uppercase Characters	
        `;
        break;
      case 'minimumNumberOfNumericCharacters':
        inputProps.min = min;
        inputProps.max = max;
        inputProps.title = `Enter a value between ${min} and ${max} for Minimum Number of Numeric Characters	
        `;
        break;
      case 'minimumNumberOfSpecialCharacters':
        inputProps.min = min;
        inputProps.max = max;
        inputProps.title = `Enter a value between ${min} and ${max} for Minimum Number of Special Characters	
        `;
        break;
      case 'passwordHistoryCount':
        inputProps.min = min;
        inputProps.max = max;
        inputProps.title = `Enter a value between ${min} and ${max} for Password History Count	
        `;
        break;
      case 'maximumLoginFailures':
        inputProps.min = min;
        inputProps.max = max;
        inputProps.title = `Enter a value between ${min} and ${max} for Maximum Login Failures	
        `;
        break;
      case 'passwordResetDuration':
        inputProps.min = min;
        inputProps.max = max;
        inputProps.title = `Enter a value between ${min} and ${max} for Password Reset Duration	
        `;
        break;
      default:
        break;
    }
    inputProps.pattern = '[0-9]*';
  }
  return { inputProps, isValidInput };
};
